import { useRef, useState } from 'react';
import BoardsPanel from './BoardsPanel';

// Coluna "Quadros" — só contador (nunca lista quadros na célula, a lista pode
// ter centenas de linhas). Clique abre o painel lateral — arquitetura-v2.md §6.6.
export default function BoardsCell({ user, role, boards, canEdit }) {
  const [open, setOpen] = useState(false);
  const btnRef = useRef(null);
  const total = boards?.total ?? 0;
  const overrides = boards?.overrides ?? 0;

  return (
    <div className="relative">
      <button
        ref={btnRef}
        type="button"
        onClick={() => setOpen(true)}
        className="text-xs text-text-primary hover:text-accent transition-colors text-left"
      >
        {total} {total === 1 ? 'quadro' : 'quadros'}
        {overrides > 0 && (
          <span className="text-warning ml-1">
            · {overrides} {overrides === 1 ? 'exceção' : 'exceções'}
          </span>
        )}
      </button>

      {open && (
        <BoardsPanel
          anchorRef={btnRef}
          user={user}
          role={role}
          canEdit={canEdit}
          onClose={() => setOpen(false)}
        />
      )}
    </div>
  );
}
